module.exports = __webpack_public_path__ + "static/img-build-06b1fdf223cf09d0e6f96c6872f5897f.jpg";